export default "__VITE_ASSET__CISLhsA1__"